import { TrendingUp } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts';

const CHART_TICK = { fill: '#AAAAAA', fontSize: 11 };
const CHART_AXIS = { stroke: '#2A2A2E' };
const CHART_TOOLTIP = { backgroundColor: '#1B1B1B', border: '1px solid #2A2A2E', borderRadius: '6px', color: '#FFFFFF' };

export function WeightChartCard({ weightChartData, currentWeight }) {
  if (weightChartData.length <= 1) return null;
  return (
    <div className="bg-[#1B1B1B] border border-[#2A2A2E] rounded-lg p-4" data-testid="weight-chart">
      <div className="flex items-center justify-between mb-2">
        <h2 className="text-xl text-white" style={{ fontFamily: "'Bebas Neue', sans-serif" }}>
          <TrendingUp className="w-5 h-5 text-[#FF6B35] inline mr-1 mb-0.5" /> Poids
        </h2>
        {currentWeight && (
          <span className="font-mono text-xl font-bold text-white">{currentWeight}<span className="text-sm text-zinc-500">kg</span></span>
        )}
      </div>
      <div className="h-32" style={{ minHeight: '128px' }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={weightChartData}>
            <XAxis dataKey="date" tick={CHART_TICK} axisLine={CHART_AXIS} tickLine={false} />
            <YAxis tick={CHART_TICK} axisLine={false} tickLine={false} width={32} domain={['dataMin - 1', 'dataMax + 1']} />
            <Tooltip contentStyle={CHART_TOOLTIP} />
            <Line type="monotone" dataKey="kg" stroke="#FF6B35" strokeWidth={2} dot={{ fill: '#FF6B35', r: 3 }} />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
